import { Text } from '@chakra-ui/react';
import { ColumnFilter } from '@tanstack/react-table';
import { Column } from 'react-table';

import BasicBooleanFilter from './bool/BasicBooleanFilter';
import DateInRangeFilter from './date/DateInRangeFilter';
import BasicStringFilter from './string/BasicStringFilter';

export enum FilterType {
  STRING = 'string',
  BOOLEAN = 'boolean',
  DATE = 'date',
  UNSUPPORTED = 'unsupported',
}

type Props = {
  column: Column<any>;
  filterType: FilterType;
  columnFilters: ColumnFilter[];
  setColumnFilters: (filters: ColumnFilter[]) => void;
};

function UnsupportedFilter() {
  return <Text>Unsupported filter type</Text>;
}

export default function NewFilterComponent({
  column,
  filterType,
  columnFilters,
  setColumnFilters,
}: Props) {
  const updateFilter = (value: unknown) => {
    const newValue = columnFilters.filter((elem) => elem.id !== column.id);
    if (filterType !== FilterType.STRING || value !== '') {
      newValue.push({
        id: column?.id || 'SHOULD_NOT_HAPPEN',
        value,
      });
    }

    setColumnFilters(newValue);
  };

  switch (filterType) {
    case FilterType.STRING:
      return <BasicStringFilter onChange={updateFilter} />;
    case FilterType.BOOLEAN:
      return <BasicBooleanFilter onChange={updateFilter} />;
    case FilterType.DATE:
      return <DateInRangeFilter onChange={updateFilter} />;
    default:
      console.log('DEBUG >> unsupported filter type', filterType);
      return <UnsupportedFilter />;
  }
}
